import axios from 'axios';

import { useEffect, useRef, useState } from 'react'

// Redux.
import { connect } from 'react-redux';

import { setNextPreviewsInfo } from "../redux/actions/dataActions";
import { WebStoriesOutlined } from "@mui/icons-material";
import { loadTrack } from "./audioHelper";
import PreviewInfos from './PreviewInfos';


const PodcastPreviews = (props) => {
    const {
        podcast,

        // Redux
        setNextPreviewsInfo,
    } = props;

    const [trackInfos, setTrackInfos] = useState([]);

    // const playPreviewsClick = () => {
    //     const shuffledPreviews = shuffle(podcast.previews);
    //     playPreviews(shuffledPreviews);
    // }

    // const playPreviews = (previewsToPlay) => {
    //     loadTrack(previewsToPlay[0].mp3URL, 0)
    //     setNextPreviewsInfo(previewsToPlay);
    //     document.getElementById('audio').pause();
    //     navigate('/previews', { state: { closeAllModal: true } });
    // }

    // useEffect(() => {
    //     axios
    //         .post('/podcast_tracks', {
    //             podcastId: podcastId,
    //             onlyEpisodesWithAI: false
    //         })
    //         .then((res) => {
    //             setTrackInfos(res.data.trackInfos);
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //         });
    // }, [podcastId]);

    return (
        <div>
            {
                podcast.previews.length === 0 ?
                    <></>
                    :
                    <div>
                        <div className='entityInfoSectionTitle'>
                            Previews
                        </div>
                        {/* {
                            trackInfos.map((trackInfo, index) => (
                                <div key={index} style={{ marginLeft: '20px', padding: '10px 0px', borderTop: index === 0 ? '' : '1px solid rgb(224, 224, 224)' }}>
                                    <PodcastTrack trackInfo={trackInfo} authenticated={authenticated} />
                                </div>
                            ))
                        } */}
                        <div style={{ margin: '10px 0px 30px'}}>
                            <PreviewInfos previews={podcast.previews} />
                        </div>
                        
                    </div>
            }
        </div >
    );
}

PodcastPreviews.propTypes = {

}

PodcastPreviews.defaultProps = {

}

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated,
})

const mapActionsToProps = {
    setNextPreviewsInfo,

}

export default connect(mapStateToProps, mapActionsToProps)(PodcastPreviews);
